import { Controller } from "remult";

@Controller("skill-methods")
export class SkillMethods {}
